var styleDataHash = "349cb01e";
const injectCss = (() => {
  var css = `.abg1p{cursor:grab;user-select:none}.abg1p:active{cursor:grabbing}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var panel_header_default = {
  "header": "abg1p"
};
export {
  panel_header_default as default,
  injectCss
};
//# sourceMappingURL=panel-header-scss.js.map
